import classNames from 'classnames';
import {
  ForwardRefRenderFunction,
  forwardRef,
  InputHTMLAttributes,
  ReactNode,
} from 'react';

// Rest props (checked, value, onChange, data-* …) are spread onto the
// underlying <input>, so accept anything an input does.
interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label: ReactNode;
  name: string;
  // Falls back to `name` for both the input id and the label's htmlFor.
  id?: string;
  hideLabel?: boolean;
  labelLeft?: boolean;
  error?: boolean;
  errorMsg?: string;
}

const Checkbox: ForwardRefRenderFunction<HTMLInputElement, Props> = (
  {
    label,
    name,
    id,
    hideLabel = false,
    error = false,
    errorMsg,
    labelLeft = false,
    ...props
  },
  forwardedRef
) => {
  const className = classNames('field', 'field--checkbox', {
    'field--has-error': !!error,
    'field--hidden-label': hideLabel,
  });

  return (
    <div className={className}>
      <div className="field__checkbox">
        <label htmlFor={id || name} className="field_label">
          {labelLeft === true && label}

          <input
            ref={forwardedRef}
            name={name}
            id={id || name}
            {...props}
            data-testid={`${name}Checkbox`}
            type="checkbox"
          />
          {labelLeft === false && label}
        </label>
      </div>
      {error && errorMsg && <span className="field__error">{errorMsg}</span>}
    </div>
  );
};

export default forwardRef(Checkbox);
